var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPassword(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.229,
    height: 21.851,
    viewBox: "0 0 15.229 21.851",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_486_",
    transform: "translate(-50)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_487_",
    d: "M57.615,21.851A7.611,7.611,0,0,0,63.243,9.112V5.628a5.628,5.628,0,1,0-11.256,0V9.112a7.611,7.611,0,0,0,5.628,12.738Zm.993-7.284v1.325a.993.993,0,1,1-1.986,0V14.566a1.655,1.655,0,1,1,1.986,0ZM53.973,5.628a3.642,3.642,0,1,1,7.283,0V7.55a7.6,7.6,0,0,0-7.283,0Z",
    fill: "#fff"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassword);
export default __webpack_public_path__ + "static/media/password.2cd59cc8fd23a3fc40250c2e253fa513.svg";
export { ForwardRef as ReactComponent };